<template>
    <div class="page-header">
        <div class="logo-container">
            <a href="https://www.go1.com" target="_blank" title="Go1">
                <img src="../../assets/go1_logo_v2.png">
            </a>
        </div>
        <slot name="title"></slot>
        <slot name="subtitle"></slot>
        <slot name="caption"></slot>
    </div>
</template>

<script>
export default {
    props: [
        'title',
        'subtitle',
        'caption',
    ],
}
</script>

<style scoped>
    .page-header {
        border: none;
    }

    .page-header .logo-container {
        width: 64px;
        height: 64px;
        margin: 32px auto;
    }
    .page-header .logo-container > img {
        max-width: 64px;
    }

    .page-header .title {
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        color: #22292A;
        font-weight: 500;
    }

    .page-header .subtitle {
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #666F71;
        font-weight: 400;
    }

    .page-header .caption {
        margin-top: 16px;
    }
    .page-header .caption .caption-text {
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #394446;
        font-weight: 400;
    }
</style>



// WEBPACK FOOTER //
// src/components/Generic/PageHeader.vue